export const formatPriceToReadable = (num: number) => {
    // Убираем все нечисловые символы и преобразуем к числу
    const profitVal: number = +String(Math.floor(num)).replaceAll(/\D/g, '');
  
    if (profitVal >= 1000000000) {
      // Правильное деление для миллиардов
      return { number: (profitVal / 1000000000).toFixed(2), label: 'млрд' };
    } else if (profitVal >= 1000000) {
      return { number: (profitVal / 1000000).toFixed(2), label: 'млн' };
    } else if (profitVal >= 1000) {
      // Объединяем диапазоны для тысяч
      return { number: (profitVal / 1000).toFixed(2), label: 'тыс' };
    } else {
      // Возвращаем значение без деления и с пустой меткой
      return { number: profitVal.toString(), label: '' };
    }
  };